// src/pages/Proposals/FileDialog/forms/index.js
import React from "react";

/**
 * Mapa modelKey → React.lazy(import del formulario)
 * Los modelKey deben coincidir EXACTAMENTE con:
 *  - los usados en ProposalDetailPage (tabs)
 *  - los usados en FileApiRegistry (fileCreateByModelKey, etc.)
 */
export const FormLazyByModel = {
  // CMAM — ERDA-TOF
  cmam_toferda_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cmam-toferda" */ "./CMAMTOFERDAForm")
  ),

  // CNA-STD — ERDA
  cna_std_erda_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-std-erda" */ "./CNASTDERDAForm")
  ),

  // CNA-STD — NRA
  cna_std_nra_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-std-nra" */ "./CNASTDNRAForm")
  ),

  // CNA-STD — PIGE
  cna_std_pige_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-std-pige" */ "./CNASTDPIGEForm")
  ),

  // CNA-STD — PIXE
  cna_std_pixe_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-std-pixe" */ "./CNASTDPIXEForm")
  ),

  // CNA-STD — RBS
  cna_std_rbs_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-std-rbs" */ "./CNASTDRBSForm")
  ),

  // CNA-µB — IBIC
  cna_ub_ibic_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-ub-ibic" */ "./CNAuBIBICForm")
  ),

  // CNA-µB — PIXE
  cna_ub_pixe_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-ub-pixe" */ "./CNAuBPIXEForm")
  ),

  // CNA-µB — TRIBIC (lo usas en detalle/export; añade cuando tengas el formulario)
  cna_ub_tribic_files: React.lazy(() =>
    import(/* webpackChunkName: "form-cna-ub-tribic" */ "./CNAuBTRIBICForm")
  ),
};
